import React, { forwardRef } from 'react'

export interface InputProps {
  label?: string
  placeholder?: string
  type?: 'text' | 'email' | 'password' | 'number' | 'tel'
  value?: string | number
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void
  error?: string
  disabled?: boolean
  required?: boolean
  className?: string
  min?: string | number
  max?: string | number
  step?: string | number
  clearOnFocus?: boolean
}

const Input = forwardRef<HTMLInputElement, InputProps>(({ 
label,
placeholder,
type = 'text',
value,
onChange,
onFocus,
error,
disabled = false,
required = false,
className = '',
  min,
  max,
  step,
  clearOnFocus = false
}, ref) => {
  const inputClasses = `
    w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
    ${error ? 'border-red-500' : 'border-gray-300'}
    ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'}
    ${className}
  `
  
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    if (clearOnFocus && type === 'number' && (value === 0 || value === '0')) {
      // input element의 값을 직접 비우기
      e.target.value = ''
      // onChange 핸들러 호출하여 상태 업데이트
      if (onChange) {
        const event = {
          target: {
            value: ''
          }
        } as React.ChangeEvent<HTMLInputElement>
        onChange(event)
      }
    }
    if (onFocus) {
      onFocus(e)
    }
  }
  
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        ref={ref}
        type={type}
        value={value}
        onChange={onChange}
        onFocus={handleFocus}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        min={min}
        max={max}
        step={step}
        className={inputClasses}
      />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  )
})

Input.displayName = 'Input'

export default Input